/** RTE-X11.5b — one-click inject application into live route. */
export function isLiveApplicationInjectionEnabled(): boolean {
  return process.env.REACT_APP_LIVE_APPLICATION_INJECTION === 'true';
}
